import type { ParsedConfigActivity } from '../args/parse-argv.types';
import type { Flag } from '../flags/flags.helpers';
import { detectVulnerableConfigWrites } from './detect-vulnerable-config-writes';
import { detectVulnerableFlags } from './detect-vulnerable-flags';
import type { Vulnerability } from './vulnerability.types';

export function vulnerabilityAnalysis(
   task: null | string,
   flags: Flag[],
   config: ParsedConfigActivity
): Vulnerability[] {
   return [...detectVulnerableFlags(task, flags), ...detectVulnerableConfigWrites(config)];
}
